import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum PolicyValue {
  moderate = 'moderate',
  relaxed = 'relaxed',
  firm = 'firm',
  noRefund = 'no_refund',
  strict = 'strict',
}

export default abstract class PolicyModel extends Model {
  @attr('string', {
    defaultValues: PolicyValue.noRefund,
  })
  value!: PolicyValue;

  @belongsTo('property', { inverse: 'policy', async: false })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    policy: PolicyModel;
  }
}
